"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Model = exports.attribute = void 0;
var Storage_1 = require("./Storage");
var Query_1 = require("./Query");
function attribute() {
    return function (target, key) {
        var BaseModel = target.constructor;
        var model = new BaseModel();
        BaseModel.setAttribute(key, model[key]);
    };
}
exports.attribute = attribute;
var Model = /** @class */ (function () {
    // protected static get schema_map(): AttributeMap {
    //   return new Map(Object.keys(this.schema).map(attribute => [ attribute, this.schema[attribute] ]))
    // }
    function Model() {
        var _this = this;
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        this.$attributes = {
            local: {},
            storage: null,
        };
        this.schema = this.constructor.schema;
        this.id = null;
        var _loop_1 = function (property) {
            Object.defineProperty(this_1, property, {
                get: function () { return _this.attributes[property]; },
                set: function (value) { return _this.attributes[property] = value; }
            });
            this_1.setAttribute(property, this_1.schema[property]);
        };
        var this_1 = this;
        for (var property in this.getAttributes()) {
            _loop_1(property);
        }
    }
    Object.defineProperty(Model, "schema", {
        get: function () {
            if (!this.schemes.has(this)) {
                this.schemes.set(this, { id: null });
            }
            return this.schemes.get(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model, "$adapter", {
        get: function () {
            if (!this.$adapters.has(this)) {
                this.$adapters.set(this, new this.adapter);
            }
            return this.$adapters.get(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "$adapter", {
        get: function () {
            return this.constructor.$adapter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "$query", {
        get: function () {
            return this.constructor.$adapter;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "$persistent", {
        get: function () {
            return this.attributes.id != undefined;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Model.prototype, "attributes", {
        get: function () {
            var _this = this;
            var attributes = { id: null };
            var _loop_2 = function (attribute_1) {
                Object.defineProperty(attributes, attribute_1, {
                    get: function () { return _this.getAttribute(attribute_1); },
                    set: function (value) { return _this.setAttribute(attribute_1, value); }
                });
            };
            for (var attribute_1 in this.getAttributes()) {
                _loop_2(attribute_1);
            }
            return attributes;
        },
        enumerable: false,
        configurable: true
    });
    Model.prototype.getAttributes = function () {
        var attributes = { id: null };
        for (var attribute_2 in this.schema) {
            attributes[attribute_2] = this.getAttribute(attribute_2);
        }
        return attributes;
    };
    Model.prototype.getAttribute = function (attribute) {
        return attribute in this.$attributes.local ? this.$attributes.local[attribute] : this.$attributes.storage ? this.$attributes.storage[attribute] : null;
    };
    Model.prototype.setAttribute = function (attribute, value) {
        return this.$attributes.local[attribute] = value;
    };
    Model.prototype.setAttributes = function (attributes) {
        for (var attribute_3 in attributes) {
            this.setAttribute(attribute_3, attributes[attribute_3]);
        }
    };
    Model.setAttribute = function (key, value) {
        this.schema[key] = value;
    };
    Model.prototype.save = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        _a = this.$attributes;
                        return [4 /*yield*/, this.$adapter.insert(__assign(__assign({}, this.$attributes.local), { id: this.getAttribute('id') }))];
                    case 1:
                        _a.storage = _b.sent();
                        this.$attributes.local = {};
                        return [2 /*return*/];
                }
            });
        });
    };
    Model.prototype.reset = function () {
        this.$attributes.local = {};
        if (!this.$persistent) {
            this.setAttributes(this.schema);
        }
    };
    Model.prototype.remove = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$adapter.remove(this.getAttribute('id'))];
                    case 1:
                        _a.sent();
                        this.$attributes.local = __assign(__assign({}, this.getAttributes()), { id: null });
                        this.$attributes.storage = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    Model.find = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var attributes;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$adapter.get(id)];
                    case 1:
                        attributes = _a.sent();
                        if (attributes == undefined) {
                            throw new Error("Model with id \"" + id + "\" was not found");
                        }
                        return [2 /*return*/, this.fromStorage(attributes)];
                }
            });
        });
    };
    Model.create = function (attributes) {
        if (attributes === void 0) { attributes = {}; }
        return __awaiter(this, void 0, void 0, function () {
            var instance;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        instance = new this();
                        instance.setAttributes(attributes);
                        return [4 /*yield*/, instance.save()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/, instance];
                }
            });
        });
    };
    Model.make = function (attributes) {
        if (attributes === void 0) { attributes = {}; }
        var instance = new this();
        instance.setAttributes(attributes);
        return instance;
    };
    Model.fromStorage = function (attributes) {
        var instance = new this();
        instance.$attributes.storage = attributes;
        instance.reset();
        return instance;
    };
    Model.query = function () {
        var _this = this;
        var query = new this.$query(this.$adapter.all(), function () { return true; }, function (attributes) { return _this.fromStorage(attributes); }, function (instance) { return instance.$attributes.storage; });
        this.$adapter.refreshables.push(query);
        return query;
    };
    Model.schemes = new Map();
    Model.$adapters = new Map();
    Model.adapter = Storage_1.ThrottledReactiveStorageAdapter;
    Model.$query = Query_1.MappedQuery;
    __decorate([
        attribute()
    ], Model.prototype, "id", void 0);
    return Model;
}());
exports.Model = Model;
